import React from "react";
import { Link } from "react-router-dom";
import tools from "../../../helpers/tools";
import { getOrientationTypeLabel } from "../../../helpers/orientationTypes";
import { Pill } from "../../common/DataList";

// Cellules de la liste des allocataires — composants de présentation purs.

const dash = "—";

export const RecipientIdentityCell = ({ recipient }) => {
  const fullname = tools.getFullname(recipient) || dash;
  return (
    <div>
      <Link to={`/recipients/${recipient.id}`} className="recipient-name">
        {fullname}
      </Link>
      <span className="cell-secondary">Créé le {tools.formatDate(recipient.createdAt)}</span>
    </div>
  );
};

export const RecipientIdsCell = ({ recipient }) => (
  <div>
    <span className="cell-primary cell-mono">{recipient.nir || dash}</span>
    <span className="cell-secondary">Matr. {recipient.CAFId || dash}</span>
  </div>
);

export const RecipientContactCell = ({ recipient }) => (
  <div>
    {recipient.email ? (
      <a href={`mailto:${recipient.email}`} className="text-reset">
        {recipient.email}
      </a>
    ) : (
      <span className="text-muted">{dash}</span>
    )}
    {recipient.emailOrigin && (
      <div>
        <Pill tone="info">sid : {recipient.emailOrigin}</Pill>
      </div>
    )}
    <span className="cell-secondary cell-mono">{recipient.phone || dash}</span>
  </div>
);

export const BooleanPill = ({ value, yes = "Oui", no = "Non" }) =>
  value ? (
    <Pill tone="ok" icon="fa-check">
      {yes}
    </Pill>
  ) : (
    <Pill tone="ko" icon="fa-times">
      {no}
    </Pill>
  );

export const RecipientLocationCell = ({ location }) =>
  location ? (
    <span>
      {location.postalCode} {location.name}
    </span>
  ) : (
    <span className="text-muted">{dash}</span>
  );

export const RightsAndDutiesPill = ({ rightsAndDuties }) => {
  const libelle = tools.getDroitsEtDevoirLibelle(rightsAndDuties || []);
  return <Pill tone={libelle === "SDD" ? "info" : "muted"}>{libelle || dash}</Pill>;
};

export const getOriginLabel = (origin, constants = {}) =>
  origin ? tools.findIn(constants.RECIPIENT_ORIGINS || [], "id", origin).name || origin : dash;

export const RecipientOrientationCell = ({ orientation, orgs = [] }) => {
  if (!orientation || !orientation.orientation) return <span className="text-muted">{dash}</span>;
  const org = tools.findIn(orgs, "slugName", orientation.orientation);
  return (
    <div>
      <span>{org.name || orientation.orientation}</span>
      <span className="cell-secondary">
        {[getOrientationTypeLabel(orientation.type), tools.formatDate(orientation.createdAt)]
          .filter(Boolean)
          .join(" · ")}
      </span>
    </div>
  );
};

export const RecipientActionsCell = ({ recipient }) => (
  <Link
    to={`/recipients/${recipient.id}`}
    className="btn btn-outline-primary btn-icon"
    aria-label={`Voir la fiche de ${tools.getFullname(recipient) || "l'allocataire"}`}
    title="Voir la fiche"
  >
    <i className="fa fa-eye" aria-hidden="true" />
  </Link>
);
